import React from 'react';
import { TrendingUp } from 'lucide-react';

const ViewValueLogo = () => {
  return (
    <div className="flex items-center space-x-2">
      <TrendingUp className="w-7 h-7 sm:w-8 sm:h-8 text-blue-600" />
      <span className="text-2xl sm:text-3xl font-bold text-gray-900">ViewValue.io</span>
    </div>
  );
};

export default ViewValueLogo;
